import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { AuthService } from '@bp2s/core/auth/auth.service';
import { ConfigurationService } from '@bp2s/core/services/configuration.service';
import { MOCK_AUTH_TOKEN } from '@bp2s/core/auth/auth.consts';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private configService: ConfigurationService,

    private auth: AuthService
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (this.configService.configuration?.auth?.mocked) {
      req = req.clone({
        headers: req.headers.set(
          'Authorization',
          this.auth.isLoggedIn()
            ? this.auth.getAuthorizationHeaderValue()
            : MOCK_AUTH_TOKEN
        ),
      });
      return next.handle(req);
    }

    req = req.clone({
      headers: req.headers.set(
        'Authorization',
        this.auth.getAuthorizationHeaderValue()
      ),
    });

    return next.handle(req);
  }
}
